(() => {
  // Sections may include this shared asset more than once. Reuse one listener.
  if (window.mpRailsRuntime) {
    window.mpRailsRuntime.boot(document);
    return;
  }
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const initialise = (root) => {
    if (!root || root.dataset.mpRailReady === 'true') return;
    const track = root.querySelector('[data-mp-rail-track]');
    const previous = root.querySelector('[data-mp-rail-prev]');
    const next = root.querySelector('[data-mp-rail-next]');
    if (!track || !previous || !next) return;

    root.dataset.mpRailReady = 'true';

    const visibleItems = () => Array.from(track.children).filter((item) => {
      const style = window.getComputedStyle(item);
      return !item.hidden && style.display !== 'none' && style.visibility !== 'hidden';
    });

    const step = () => {
      const item = visibleItems()[0];
      if (!item) return Math.max(240, track.clientWidth * 0.85);
      const style = window.getComputedStyle(track);
      const gap = parseFloat(style.columnGap || style.gap || 0) || 0;
      return item.getBoundingClientRect().width + gap;
    };

    const update = () => {
      const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= maximum - 2 || maximum <= 2;
    };

    const move = (direction) => {
      track.scrollBy({
        left: direction * step(),
        behavior: reducedMotion.matches ? 'auto' : 'smooth'
      });
    };

    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    track.addEventListener('scroll', update, { passive: true });

    if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
    if ('MutationObserver' in window) {
      new MutationObserver(() => {
        track.scrollTo({ left: 0, behavior: 'auto' });
        window.requestAnimationFrame(update);
      }).observe(track, { attributes: true, childList: true, subtree: true, attributeFilter: ['hidden'] });
    }

    window.requestAnimationFrame(update);
  };

  const boot = (scope = document) => {
    scope.querySelectorAll('[data-mp-rail]').forEach(initialise);
  };
  window.mpRailsRuntime = { boot };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot(), { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
